import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { replacePathParams } from 'libs/helpers/functions';
import { EPath } from 'constants/routes';
import AssignmentsStartRules from './AssignmentsStartRules';

const AssignmentsStartRulesContainer = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const handleBackPage = () => {
    history.push(replacePathParams(EPath.U5_2, { id }));
  };
  const handleNextPage = () => {
    history.push(replacePathParams(EPath.U6_2, { id }));
  };

  return <AssignmentsStartRules handleBackPage={handleBackPage} handleNextPage={handleNextPage} />;
};

export default AssignmentsStartRulesContainer;
